import React from 'react';
import '../styles/OfficeMap.css';
import locationIcon from '../assets/map.png';

const OfficeMap = () => {
  const googleMapsUrl = " https://maps.app.goo.gl/ECSxZPUrfERoSrCa6";

  return (
    <section id="office-address" className="office-address-section">
      <div className="office-address-container">
        
        {/* Section Header */}
        <div className="office-address-header">
          <span className="office-address-tagline">Visit Us</span>
          <h2 className="office-address-title">
            Our <span className="office-address-highlight">Office Location</span>
          </h2>
          <div className="office-address-underline"></div>
          <p className="office-address-subtitle">
            We're located in the heart of Kolkata's business district. Come visit us for a meeting or facility tour.
          </p>
        </div>

        <div className="office-address-wrapper">
          
          {/* Left Side - Address Details */}
          <div className="office-address-info">
            <div className="office-address-card">
              <div className="office-address-card-header">
                <div className="office-address-card-icon">
                  <img src={locationIcon} alt="Location" />
                </div>
                <h3>Registered Office</h3>
              </div>
              
              <div className="office-address-details">
                <div className="office-address-detail-item">
                  <span className="office-address-detail-icon">🏢</span>
                  <div>
                    <strong>Company Name</strong>
                    <p>Preferred Audiology Pvt. Ltd.</p>
                  </div>
                </div>
                
                <div className="office-address-detail-item">
                  <span className="office-address-detail-icon">📍</span>
                  <div>
                    <strong>Complete Address</strong>
                    <p>
                      Ecospace Business Towers, Tower 5A,<br />
                      Office no. 508, 5th Floor, New Town,<br />
                      Action Area II, Street No. 05-0372,<br />
                      Kolkata - 700160, West Bengal
                    </p>
                  </div>
                </div>
                
                <div className="office-address-detail-item">
                  <span className="office-address-detail-icon">🗺️</span>
                  <div>
                    <strong>Landmark</strong>
                    <p> Beside Ecospace Residencia</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="office-address-hours">
              <h4>Business Hours</h4>
              <div className="office-address-hours-list">
                <div className="office-address-hour-item">
                  <span>Monday - Friday</span>
                  <strong>10:00 AM - 6:00 PM</strong>
                </div>
              
                <div className="office-address-hour-item closed">
                  <span>Saturday & Sunday</span>
                  <strong>Closed</strong>
                </div>
              </div>
            </div>

            <div className="office-address-parking">
              <div className="office-address-parking-icon">🅿️</div>
              <div className="office-address-parking-content">
                <strong>Parking Information</strong>
                <p>Ample parking space available in the Ecospace business Tower. Visitor parking on ground floor and basement levels.</p>
              </div>
            </div>

            <div className="office-address-directions">
              <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer" className="office-address-directions-btn">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="12" cy="9" r="2.5" stroke="currentColor" strokeWidth="2"/>
                </svg>
                Get Directions
              </a>
              <a href="#contact-form" className="office-address-meeting-btn">
                📅 Schedule a Visit
              </a>
            </div>
          </div>

          {/* Right Side - Google Map */}
          <div className="office-address-map">
            <div className="office-address-map-container">
              <iframe
                title="Preferred Audiology Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.0!2d88.4762696!3d22.5764404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a020b1a7b2a0e0b%3A0x8e5e3b3c6b0b1a0f!2sEcospace%20Business%20Towers!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="office-address-map-badge">
              <span>📍 Tower 5A, 5th Floor</span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default OfficeMap;